// src/i18n/locales/pt.js

export default {
  countries: {
    'AF': 'Afeganistão',
    'AL': 'Albânia',
    'DZ': 'Argélia',
    'AD': 'Andorra',
    'AO': 'Angola',
    'AG': 'Antígua e Barbuda',
    'AR': 'Argentina',
    'AM': 'Armênia',
    'AU': 'Austrália',
    'AT': 'Áustria',
    'AZ': 'Azerbaijão',
    'BS': 'Bahamas',
    'BH': 'Bahrein',
    'BD': 'Bangladesh',
    'BB': 'Barbados',
    'BY': 'Bielorrússia',
    'BE': 'Bélgica',
    'BZ': 'Belize',
    'BJ': 'Benim',
    'BT': 'Butão',
    'BO': 'Bolívia',
    'BA': 'Bósnia e Herzegovina',
    'BW': 'Botsuana',
    'BR': 'Brasil',
    'BN': 'Brunei',
    'BG': 'Bulgária',
    'BF': 'Burquina Faso',
    'BI': 'Burundi',
    'CV': 'Cabo Verde',
    'KH': 'Camboja',
    'CM': 'Camarões',
    'CA': 'Canadá',
    'CF': 'República Centro-Africana',
    'TD': 'Chade',
    'CL': 'Chile',
    'CN': 'China',
    'CO': 'Colômbia',
    'KM': 'Comores',
    'CG': 'Congo',
    'CD': 'Congo, República Democrática do',
    'CR': 'Costa Rica',
    'CI': 'Costa do Marfim',
    'HR': 'Croácia',
    'CU': 'Cuba',
    'CY': 'Chipre',
    'CZ': 'Tchéquia',
    'DK': 'Dinamarca',
    'DJ': 'Djibuti',
    'DM': 'Dominica',
    'DO': 'República Dominicana',
    'EC': 'Equador',
    'EG': 'Egito',
    'SV': 'El Salvador',
    'GQ': 'Guiné Equatorial',
    'ER': 'Eritreia',
    'EE': 'Estônia',
    'ET': 'Etiópia',
    'FJ': 'Fiji',
    'FI': 'Finlândia',
    'FR': 'França',
    'GA': 'Gabão',
    'GM': 'Gâmbia',
    'GE': 'Geórgia',
    'DE': 'Alemanha',
    'GH': 'Gana',
    'GR': 'Grécia',
    'GD': 'Granada',
    'GT': 'Guatemala',
    'GN': 'Guiné',
    'GW': 'Guiné-Bissau',
    'GY': 'Guiana',
    'HT': 'Haiti',
    'HN': 'Honduras',
    'HU': 'Hungria',
    'IS': 'Islândia',
    'IN': 'Índia',
    'ID': 'Indonésia',
    'IR': 'Irã',
    'IQ': 'Iraque',
    'IE': 'Irlanda',
    'IL': 'Israel',
    'IT': 'Itália',
    'JM': 'Jamaica',
    'JP': 'Japão',
    'JO': 'Jordânia',
    'KZ': 'Cazaquistão',
    'KE': 'Quênia',
    'KI': 'Quiribati',
    'KP': 'Coreia do Norte',
    'KR': 'Coreia do Sul',
    'KW': 'Kuwait',
    'KG': 'Quirguistão',
    'LA': 'Laos',
    'LV': 'Letônia',
    'LB': 'Líbano',
    'LS': 'Lesoto',
    'LR': 'Libéria',
    'LY': 'Líbia',
    'LI': 'Liechtenstein',
    'LT': 'Lituânia',
    'LU': 'Luxemburgo',
    'MG': 'Madagáscar',
    'MW': 'Malaui',
    'MY': 'Malásia',
    'MV': 'Maldivas',
    'ML': 'Mali',
    'MT': 'Malta',
    'MH': 'Ilhas Marshall',
    'MR': 'Mauritânia',
    'MU': 'Maurício',
    'MX': 'México',
    'FM': 'Micronésia',
    'MD': 'Moldávia',
    'MC': 'Mônaco',
    'MN': 'Mongólia',
    'ME': 'Montenegro',
    'MA': 'Marrocos',
    'MZ': 'Moçambique',
    'MM': 'Mianmar',
    'NA': 'Namíbia',
    'NR': 'Nauru',
    'NP': 'Nepal',
    'NL': 'Países Baixos',
    'NZ': 'Nova Zelândia',
    'NI': 'Nicarágua',
    'NE': 'Níger',
    'NG': 'Nigéria',
    'MK': 'Macedônia do Norte',
    'NO': 'Noruega',
    'OM': 'Omã',
    'PK': 'Paquistão',
    'PW': 'Palau',
    'PS': 'Palestina',
    'PA': 'Panamá',
    'PG': 'Papua-Nova Guiné',
    'PY': 'Paraguai',
    'PE': 'Peru',
    'PH': 'Filipinas',
    'PL': 'Polônia',
    'PT': 'Portugal',
    'QA': 'Catar',
    'RO': 'Romênia',
    'RU': 'Rússia',
    'RW': 'Ruanda',
    'KN': 'São Cristóvão e Nevis',
    'LC': 'Santa Lúcia',
    'VC': 'São Vicente e Granadinas',
    'WS': 'Samoa',
    'SM': 'San Marino',
    'ST': 'São Tomé e Príncipe',
    'SA': 'Arábia Saudita',
    'SN': 'Senegal',
    'RS': 'Sérvia',
    'SC': 'Seicheles',
    'SL': 'Serra Leoa',
    'SG': 'Singapura',
    'SK': 'Eslováquia',
    'SI': 'Eslovênia',
    'SB': 'Ilhas Salomão',
    'SO': 'Somália',
    'ZA': 'África do Sul',
    'SS': 'Sudão do Sul',
    'ES': 'Espanha',
    'LK': 'Sri Lanka',
    'SD': 'Sudão',
    'SR': 'Suriname',
    'SZ': 'Eswatini',
    'SE': 'Suécia',
    'CH': 'Suíça',
    'SY': 'Síria',
    'TW': 'Taiwan',
    'TJ': 'Tadjiquistão',
    'TZ': 'Tanzânia',
    'TH': 'Tailândia',
    'TL': 'Timor-Leste',
    'TG': 'Togo',
    'TO': 'Tonga',
    'TT': 'Trinidad e Tobago',
    'TN': 'Tunísia',
    'TR': 'Turquia',
    'TM': 'Turcomenistão',
    'TV': 'Tuvalu',
    'UG': 'Uganda',
    'UA': 'Ucrânia',
    'AE': 'Emirados Árabes Unidos',
    'GB': 'Reino Unido',
    'US': 'Estados Unidos',
    'UY': 'Uruguai',
    'UZ': 'Uzbequistão',
    'VU': 'Vanuatu',
    'VA': 'Cidade do Vaticano',
    'VE': 'Venezuela',
    'VN': 'Vietnã',
    'YE': 'Iêmen',
    'ZM': 'Zâmbia',
    'ZW': 'Zimbábue'
  },
  verification: {
    verifying: 'Verificando seu e-mail...',
    success: 'E-mail Verificado com Sucesso!',
    failed: 'Falha na Verificação',
    accountVerified: 'Sua conta foi verificada com sucesso. Você pode agora fazer login na sua conta.',
    invalidLink: 'O link de verificação é inválido ou expirou.',
    missingToken: 'Token de verificação está ausente.',
    generalError: 'Ocorreu um erro durante a verificação. Por favor, tente novamente mais tarde.',
    proceedToLogin: 'Prosseguir para o Login',
    backToLogin: 'Voltar ao Login'
  },
  admin: {
    huduma: 'Genie AI',
    dashboard: 'Painel',
    system: 'Sistema',
    settings: 'Configurações',
    overview: 'Visão Geral',
    database: 'Banco de Dados',
    logs: 'Logs',
    userManagement: 'Gerenciamento de Usuários',
    security: 'Segurança',
    systemAdministration: 'Administração do Sistema',
    loading: 'Carregando...',
    close: 'Fechar painel',
    edit: 'Editar',
    systemUptime: 'Tempo de Atividade do Sistema',
    avgResponseTime: 'Tempo Médio de Resposta',
    errorRate: 'Taxa de Erro',
    activeUsers: 'Usuários Ativos',
    monthlyActiveUsers: 'Usuários Ativos Mensais (MAU)',
    fromLastMonth: 'do mês passado',
    today: 'Hoje',
    // --- UPDATED TABS ---
    tabs: {
      overview: 'Saúde do Sistema',
      hierarchy: 'Hierarquia de Conhecimento', // NEW
      documents: 'Gerenciamento de Documentos', // NEW
      database: 'Banco de Dados',
      logs: 'Logs',
      security: 'Segurança',
      users: 'Usuários'
    },
    // --- NEW KEYS ---
    contentManagement: "GERENCIAMENTO DE CONTEÚDO",
    knowledgeHierarchy: "Hierarquia de Conhecimento",
    documentManagement: "Gerenciamento de Documentos",
    noLogsFound: "Nenhum log encontrado para hoje",
    invalidLogsResponse: "Estrutura de resposta do resumo de logs inválida",
    logsSummaryError: "Falha ao carregar o resumo de logs",
    buttons: {
      save: "Salvar",
      cancel: "Cancelar",
      switch: "Mudar Mesmo Assim",
      discard: "Descartar"
    },
    confirm: {
      defaultTitle: "Confirmar",
      defaultMessage: "Você tem certeza?"
    },
    // --- END NEW KEYS ---
    systemHealthStatus: 'Status de Saúde do Sistema',
    runDiagnostics: 'Executar Diagnósticos',
    resourceUsage: 'Uso de Recursos',
    services: {
      apiServices: 'Serviços API',
      database: 'Banco de Dados',
      cache: 'Cache',
      storage: 'Armazenamento',
      messageQueue: 'Fila de Mensagens',
      externalApi: 'API Externa'
    },
    resources: {
      cpu: 'Uso de CPU',
      memory: 'Uso de Memória',
      storage: 'Uso de Armazenamento',
      network: 'Largura de Banda de Rede'
    },
    databaseManagement: 'Gerenciamento de Banco de Dados',
    reindexDatabase: 'Reindexar Banco de Dados',
    lastReindex: 'Última Reindexação',
    databaseSize: 'Tamanho do Banco de Dados',
    totalTables: 'Total de Tabelas',
    logManagement: 'Gerenciamento de Logs',
    rolloverLogs: 'Rolar Logs',
    searchLogs: 'Buscar Logs',
    logTime: 'Tempo',
    logLevel: 'Nível',
    logService: 'Serviço',
    logMessage: 'Mensagem',
    showingEntries: 'Mostrando {start}-{end} de {total} entradas',
    logLevels: {
      error: 'ERRO',
      warn: 'AVISO',
      info: 'INFO',
      debug: 'DEBUG'
    },
    logMessages: {
      connectionTimeout: 'Tempo limite de conexão com provedor externo',
      lowDiskSpace: 'Espaço em disco abaixo de 10% do limite',
      userRoleUpdated: 'Função do usuário atualizada para admin@huduma.ai'
    },
    userName: 'Nome',
    userEmail: 'E-mail',
    userRole: 'Função',
    userStatus: 'Status',
    userActions: 'Ações',
    roleAdministrator: 'Administrador',
    roleUser: 'Usuário',
    statusActive: 'Ativo',
    dbActions: {
      reindex: 'Reindexar',
      backup: 'Backup',
      optimize: 'Otimizar',
      reindexDesc: 'Reconstruir índices do banco de dados',
      backupDesc: 'Criar backup do banco de dados',
      optimizeDesc: 'Otimizar desempenho de consultas'
    },
    operations: {
      reindexTitle: 'Resultados da Reindexação do Banco de Dados',
      backupTitle: 'Resultados do Backup do Banco de Dados',
      optimizeTitle: 'Resultados da Otimização do Banco de Dados',
      reindexResults: 'Resultados da Reindexação',
      optimizeResults: 'Resultados da Otimização',
      collection: 'Coleção',
      status: 'Status',
      indexSuggestions: 'Sugestões de Índice',
      backupDetails: 'Detalhes do Backup',
      backupFile: 'Arquivo de Backup',
      backupLocation: 'Localização',
      backupSize: 'Tamanho',
      errorDetails: 'Detalhes do Erro',
      close: 'Fechar',
      resultsTitle: 'Resultados da Operação',
      reindexDatabase: {
        success: 'Reindexação do banco de dados concluída com sucesso',
        error: 'Erro durante a reindexação do banco de dados',
        loading: 'Reindexando banco de dados...'
      },
      backupDatabase: {
        success: 'Backup do banco de dados concluído com sucesso',
        error: 'Erro durante o backup do banco de dados',
        loading: 'Fazendo backup do banco de dados...'
      },
      optimizeDatabase: {
        success: 'Otimização do banco de dados concluída com sucesso',
        error: 'Erro durante a otimização do banco de dados',
        loading: 'Otimizando banco de dados...'
      },
      rolloverLogs: {
        success: 'Rolagem de logs concluída com sucesso',
        loading: 'Rolando logs...'
      },
      searchLogs: {
        success: 'Busca de logs concluída',
        loading: 'Buscando logs...'
      },
      runDiagnostics: {
        success: 'Diagnósticos concluídos com sucesso',
        loading: 'Executando diagnósticos...'
      },
      runSecurityScan: {
        success: 'Varredura de segurança concluída com sucesso',
        loading: 'Executando varredura de segurança...'
      },
      cancel: 'Cancelar',
      save: 'Salvar Alterações'
    },
    userManagementSection: {
      totalUsers: 'Total de Usuários',
      newUsers: 'Novos Usuários (Mês)',
      searchUsers: 'Buscar usuários...',
      clearSearch: 'Limpar busca',
      search: 'Buscar',
      usersFound: 'usuários encontrados',
      showAllUsers: 'Mostrar Todos os Usuários',
      searching: 'Buscando...',
      searchingUsers: 'Buscando usuários...',
      noUsersFound: 'Nenhum usuário encontrado correspondente aos seus critérios de busca.',
      noUsers: 'Nenhum usuário disponível.',
      showing: 'Mostrando',
      of: 'de',
      previous: 'Anterior',
      next: 'Próximo',
      searchFields: {
        all: 'Todos os Campos',
        name: 'Nome',
        email: 'E-mail',
        role: 'Função'
      },
      userSearch: {
        resultsFound: 'Encontrados {total} usuários correspondentes a "{term}"',
        error: 'Erro ao buscar usuários'
      }
    },
    logsSection: {
      errorLogs: 'Logs de Erro',
      warningLogs: 'Logs de Aviso',
      noErrorLogs: 'Nenhum log de erro registrado hoje.',
      noWarningLogs: 'Nenhum log de aviso registrado hoje.',
      infoLogsNote: 'Logs de informação não são mostrados no resumo. Use a função de busca para visualizar todos os tipos de log.',
      searchResults: 'Últimos Resultados de Busca',
      entriesFound: 'entradas encontradas',
      viewAllResults: 'Ver Todos os Resultados',
      logType: 'Tipo',
      logCount: 'Contagem',
      logTypes: {
        connectionTimeout: 'Tempo limite de conexão',
        databaseFailed: 'Falha na consulta do banco de dados',
        authFailed: 'Falha na autenticação',
        lowDiskSpace: 'Espaço em disco abaixo do limite',
        slowQuery: 'Desempenho de consulta lento',
        rateLimit: 'Limite de taxa se aproximando'
      },
      logSearch: {
        noResultsFound: 'Nenhum log corresponde aos seus critérios de busca',
        resultsFound: 'Encontradas {count} entradas de log'
      }
    },
    security: {
      title: 'Monitoramento de Segurança',
      securityScan: 'Varredura de Segurança',
      runningSecurityScan: 'Executando Varredura...',
      lastSecurityScan: 'Última Varredura de Segurança',
      vulnerabilitiesFound: 'Vulnerabilidades Encontradas',
      daysAgo: 'dias atrás',
      critical: 'crítico',
      medium: 'médio',
      low: 'baixo',
      failedLoginAttempts: 'Tentativas de Login Falhadas (24h)',
      suspiciousActivities: 'Atividades Suspeitas (24h)',
      securityRecommendations: 'Recomendações de Segurança',
      criticalVulnerabilities: 'Vulnerabilidades Críticas',
      mediumVulnerabilities: 'Vulnerabilidades Médias',
      lowVulnerabilities: 'Vulnerabilidades Baixas',
      authenticationIssues: 'Problemas de Autenticação',
      suspiciousActivityLogs: 'Logs de Atividades Suspeitas',
      securityProbeAttempts: 'Tentativas de Sondagem de Segurança Detectadas',
      sensitiveFileAccess: 'tentativas de acessar arquivos ou endpoints sensíveis detectadas',
      envFileAccess: 'Tentativas de Acesso a Arquivos de Ambiente',
      envFileAccessDesc: 'tentativas de acessar arquivos .env detectadas',
      gitRepoAccess: 'Tentativas de Acesso ao Repositório Git',
      gitRepoAccessDesc: 'tentativas de acessar arquivos do repositório Git detectadas',
      recommendedAction: 'Ação Recomendada',
      rateLimitRecommendation: 'Considere implementar limitação de taxa, bloqueio de IP para infratores persistentes e garantir que o hardening do servidor esteja no lugar.',
      envFileRecommendation: 'Garanta que arquivos de ambiente não sejam acessíveis de diretórios web e configurações de servidor bloqueiem adequadamente o acesso a arquivos sensíveis.',
      gitRepoRecommendation: 'Certifique-se de que diretórios .git estejam adequadamente seguros e não acessíveis da web.',
      noVulnerabilitiesFound: 'Nenhuma Vulnerabilidade Encontrada',
      systemSecure: 'Seu sistema parece seguro. Continue monitorando regularmente.',
      loadingScan: 'Carregando resultados da varredura...',
      occurrences: 'Ocorrências',
      firstSeen: 'Visto pela Primeira Vez',
      lastSeen: 'Visto pela Última Vez',
      timestamp: 'Carimbo de Tempo',
      message: 'Mensagem',
      service: 'Serviço',
      type: 'Tipo',
      severity: 'Severidade',
      url: 'URL',
      matchedTerm: 'Termo Correspondente',
      lineNumber: 'Número da Linha',
      lineNumbers: 'Números das Linhas',
      showLess: 'Mostrar Menos',
      showMore: 'Mostrar Todos os Problemas',
      // --- NEW KEY ---
      lastScanJustNow: "Agora mesmo"
    },
    userEdit: {
      title: 'Editar Usuário',
      loading: 'Carregando dados do usuário...',
      userInfo: 'Informações do Usuário',
      userId: 'ID do Usuário',
      loginName: 'Nome de Login',
      fullName: 'Nome Completo',
      dob: 'Data de Nascimento',
      email: 'E-mail',
      emailVerified: 'E-mail Verificado',
      verified: 'Verificado',
      notVerified: 'Não Verificado',
      createdAt: 'Criado',
      lastLogin: 'Último Login',
      never: 'Nunca',
      accountSettings: 'Configurações da Conta',
      accountStatus: 'Status da Conta',
      accountEnabled: 'Conta Ativada',
      cannotDisableSelf: 'Você não pode desativar sua própria conta',
      accountRole: 'Função da Conta',
      adminRole: 'Função de Admin',
      cannotChangeOwnRole: 'Você não pode alterar sua própria função',
      adminActions: 'Ações de Admin',
      verifyEmail: 'Verificar E-mail',
      resetPassword: 'Enviar Redefinição de Senha',
      forceLogout: 'Forçar Logout',
      failedToLoad: 'Falha ao carregar dados do usuário',
      errorLoading: 'Erro ao carregar dados do usuário',
      saveSuccess: 'Configurações do usuário atualizadas com sucesso',
      errorSaving: 'Erro ao salvar configurações do usuário',
      verifyEmailSuccess: 'E-mail de verificação enviado com sucesso',
      emailVerificationFailed: 'Falha ao enviar e-mail de verificação',
      errorVerifyingEmail: 'Erro ao enviar e-mail de verificação',
      passwordResetSent: 'E-mail de redefinição de senha enviado',
      passwordResetFailed: 'Falha ao enviar redefinição de senha',
      errorSendingReset: 'Erro ao enviar redefinição de senha',
      logoutForced: 'Usuário foi desconectado',
      logoutFailed: 'Falha ao forçar logout',
      errorForcingLogout: 'Erro ao forçar logout',
      // --- NEW KEY ---
      userUpdated: "Usuário atualizado com sucesso"
    },
    // --- NEW OBJECT ---
    hierarchy: {
      title: "Gerenciamento da Hierarquia de Conhecimento (nota: sempre em inglês - adicionar traduções)",
      addCategory: "Adicionar Nova Categoria",
      loading: "Carregando Hierarquia...",
      addService: "Adicionar Serviço",
      editCategory: "Editar Categoria",
      deleteCategory: "Excluir Categoria",
      editService: "Editar Serviço",
      deleteService: "Excluir Serviço",
      empty: 'Nenhuma categoria encontrada. Clique em "Adicionar Nova Categoria" para começar.',
      formTitleCreateCategory: "Criar Nova Categoria",
      formTitleAddService: 'Adicionar Serviço a "{categoryName}"',
      formTitleEditCategory: 'Editar Categoria: "{itemName}"',
      formTitleEditService: 'Editar Serviço: "{itemName}"',
      nameEnLabel: "Nome (Inglês)",
      translationsTitle: "Traduções para Exibição",
      loadingTranslations: "Carregando traduções...",
      selectLang: "Selecionar Idioma",
      translationPlaceholder: "Inserir tradução",
      deleteTranslation: "Excluir Tradução",
      addTranslation: "+ Adicionar Tradução",
      saveSuccess: "Item da hierarquia salvo com sucesso.",
      saveError: "Falha ao salvar o item da hierarquia.",
      loadError: "Falha ao carregar a hierarquia de conhecimento.",
      loadTranslationsError: "Falha ao carregar as traduções.",
      confirmCancelTitle: "Alterações Não Salvas",
      confirmCancelEdit: "Você tem alterações não salvas. Tem certeza de que deseja cancelar?",
      confirmDeleteTitleCategory: "Excluir Categoria?",
      confirmDeleteTitleService: "Excluir Serviço?",
      confirmDeleteCategory: 'Tem certeza de que deseja excluir a Categoria "{itemName}"? Esta ação não pode ser desfeita.',
      confirmDeleteService: 'Tem certeza de que deseja excluir o Serviço "{itemName}"? Esta ação não pode ser desfeita.',
      deleteSuccessCategory: "Categoria excluída com sucesso.",
      deleteSuccessService: "Serviço excluído com sucesso.",
      deleteErrorCategory: "Falha ao excluir a Categoria.",
      deleteErrorService: "Falha ao excluir o Serviço.",
      duplicateLangError: "Idiomas duplicados encontrados nas traduções. Por favor, remova-os."
    },
    // --- NEW OBJECT ---
    documents: {
      title: "Gerenciamento de Documentos",
      addLink: "Adicionar de Link",
      uploadFiles: "Carregar Arquivos",
      searchPlaceholder: "Buscar por nome do arquivo...",
      allStatuses: "Todos os Status",
      statusPending: "Pendente",
      statusIngested: "Ingerido",
      statusRetracted: "Retirado",
      // --- NEW STATUSES ADDED ---
      statusIngesting: "Ingerindo",
      statusError: "Erro de Ingestão",
      statusWarning: "Ingerido com Avisos",
      // ---
      ingestSelected: "Ingerir Selecionados",
      colFileName: "Nome do Arquivo",
      colStatus: "Status",
      colLabels: "Etiquetas",
      colUploadDate: "Data de Upload",
      colSize: "Tamanho",
      loading: "Carregando documentos...",
      empty: "Nenhum documento encontrado.",
      loadError: "Falha ao carregar documentos.",
      confirmIngestTitle: "Confirmar Ingestão em Lote",
      ingest: "Ingerir",
      confirmIngestSelected: "Tem certeza de que deseja ingerir {count} arquivo(s) selecionado(s)?",
      ingestQueuedSuccess: "{count} arquivo(s) foram enfileirados para ingestão.",
      ingestQueuedError: "Ocorreu um erro durante o processo de ingestão em lote.",
      uploadSuccessMultiple: "{count} arquivo(s) carregados com sucesso.",
      linkSubmitSuccess: 'Rastreado e salvo "{fileName}" com sucesso.',
      actionSuccess: 'Ação "{action}" no arquivo {fileId} foi bem-sucedida.',
      metadataUpdateSuccess: "Metadados do arquivo {fileId} foram atualizados."
    }
  },
  passwordResetConfirm: {
    appTitle: 'Genie AI',
    resetPassword: 'Criar Nova Senha',
    tokenLabel: 'Token de Redefinição',
    tokenPlaceholder: 'Digite o token de redefinição',
    validateButton: 'Validar Token',
    newPasswordLabel: 'Nova Senha',
    newPasswordPlaceholder: 'Crie uma nova senha',
    confirmNewPasswordLabel: 'Confirme Nova Senha',
    confirmNewPasswordPlaceholder: 'Confirme sua nova senha',
    resetButton: 'Redefinir Senha',
    processing: 'Redefinindo...',
    rememberedPassword: 'Lembrou sua senha?',
    backToLogin: 'Voltar ao Login',
    supportMessage: 'Precisa de ajuda? Contate nossa equipe de suporte',
    passwordRequirements: 'A senha deve ter pelo menos 8 caracteres com pelo menos 1 número, 1 letra maiúscula e 1 caractere especial',
    passwordsDoNotMatch: 'Senhas não coincidem',
    resetSuccess: 'Sua senha foi redefinida com sucesso',
    resetFailed: 'Não foi possível redefinir a senha. Por favor, tente novamente.',
    noTokenProvided: 'Por favor, forneça um token de redefinição',
    expiredToken: 'Este token de redefinição expirou. Por favor, solicite um novo.',
    invalidToken: 'Token de redefinição inválido ou não reconhecido',
    validatingToken: 'Validando token...',
    redirecting: 'Redirecionando para a página de login...',
    passwordStrength: 'Força da Senha',
    strengthLabels: {
      veryWeak: 'Muito Fraca',
      weak: 'Fraca',
      fair: 'Razoável',
      good: 'Boa',
      strong: 'Forte'
    },
    passwordSuggestions: {
      atLeast8Chars: 'Use pelo menos 8 caracteres',
      addUppercase: 'Adicione letras maiúsculas',
      addLowercase: 'Adicione letras minúsculas',
      addNumbers: 'Adicione números',
      addSpecialChars: 'Adicione caracteres especiais'
    }
  },
  passwordReset: {
    appTitle: 'Genie AI',
    resetPassword: 'Redefinir Sua Senha',
    emailLabel: 'Endereço de E-mail',
    emailPlaceholder: 'Digite seu e-mail',
    resetButton: 'Enviar Link de Redefinição',
    processing: 'Enviando...',
    rememberPassword: 'Lembrou sua senha?',
    backToLogin: 'Voltar ao Login',
    supportMessage: 'Precisa de ajuda? Contate nossa equipe de suporte',
    invalidEmail: 'Por favor, digite um endereço de e-mail válido',
    resetRequestSuccess: 'Link de redefinição de senha foi enviado para seu e-mail',
    resetRequestFailed: 'Não foi possível enviar o link de redefinição de senha. Por favor, tente novamente.',
    checkEmail: 'Por favor, verifique seu e-mail para instruções adicionais.'
  },
  register: {
    appTitle: "Genie AI",
    createAccount: "Criar Nova Conta",
    username: "Nome de Usuário",
    usernamePlaceholder: "Digite um nome de usuário",
    email: "E-mail",
    emailPlaceholder: "Digite seu e-mail",
    password: "Senha",
    passwordPlaceholder: "Crie uma senha",
    confirmPassword: "Confirme a Senha",
    confirmPasswordPlaceholder: "Confirme sua senha",
    acceptTerms: "Eu aceito os",
    termsOfService: "Termos de Serviço",
    registerButton: "Criar Conta",
    processing: "Processando...",
    alreadyHaveAccount: "Já tem uma conta?",
    loginNow: "Faça login",
    privacyNotice: "Ao se registrar, você concorda com nossos Termos de Serviço e Política de Privacidade",
    usernameMinLength: "O nome de usuário deve ter pelo menos 3 caracteres",
    invalidEmail: "Por favor, digite um endereço de e-mail válido",
    passwordRequirements: "A senha deve ter pelo menos 8 caracteres com pelo menos 1 número e 1 letra maiúscula",
    passwordsDoNotMatch: "Senhas não coincidem",
    mustAcceptTerms: "Você deve aceitar os Termos de Serviço",
    registrationFailed: "Falha no registro. Por favor, tente novamente.",
    usernameExists: "Nome de usuário já existe",
    emailExists: "E-mail já existe",
    registrationSuccess: "Registro Bem-Sucedido!",
    verificationEmailSent: "Um e-mail de verificação foi enviado para {email}",
    checkEmailInstructions: "Por favor, verifique seu e-mail e siga as instruções para verificar sua conta antes de fazer login.",
    backToLogin: "Voltar ao Login",
    noEmailReceived: "Não recebeu um e-mail?",
    resendVerification: "Reenviar e-mail de verificação",
    verificationResent: "E-mail de verificação reenviado",
    verificationResendFailed: "Falha ao reenviar e-mail de verificação. Por favor, tente novamente.",
    usernameInvalidChars: 'O nome de usuário pode conter apenas letras, números, underlines, pontos e hifens',
    networkError: 'Erro de rede. Por favor, verifique sua conexão e tente novamente.'
  },
  login: {
    appTitle: 'Genie AI',
    username: 'Nome de Usuário',
    password: 'Senha',
    loginButton: 'Login',
    or: 'ou',
    savedAccounts: 'Contas Salvas',
    loginSuccess: 'Login bem-sucedido',
    loginError: 'Falha no login. Por favor, verifique suas credenciais.',
    googleLogin: 'Continuar com Google',
    facebookLogin: 'Continuar com Facebook',
    rememberMe: 'Lembre-se de mim',
    forgotPassword: 'Esqueceu a senha?',
    noAccount: 'Não tem uma conta?',
    createAccount: 'Criar conta',
    registerNow: "Registre-se agora",
    termsAndPolicy: 'Ao fazer login, você concorda com nossos Termos de Serviço e Política de Privacidade',
    loggingIn: "Fazendo login...",
    fieldsRequired: "Nome de usuário e senha são obrigatórios",
    invalidCredentials: "Nome de usuário ou senha inválidos",
    tooManyAttempts: "Muitas tentativas de login. Por favor, tente novamente mais tarde.",
    loginFailed: "Falha no login. Por favor, tente novamente.",
    oauthNotImplemented: "Login social ainda não implementado",
    savedLoginNotImplemented: "Login com conta salva ainda não implementado"
  },
  charts: {
    tooltip: {
      title: 'Data',
      totalQueries: 'Consultas Totais',
      uniqueUsers: 'Usuários Únicos'
    },
    day: 'Dia',
    noData: 'Sem Dados',
    notAvailable: 'N/D',
    topQueries: 'Consultas Principais',
    categoryDistribution: 'Uso por Área de Conhecimento',
    usageTrend: 'Tendência de Uso'
  },
  analytics: {
    title: 'Análise de Dados & Insights',
    loading: 'Carregando dados de análise...',
    period: 'Período de Tempo',
    charts: {
      satisfactionHeatmap: "Satisfação por Área de Conhecimento",
      satisfactionSubtitle: "Pontuações percentuais ao longo do tempo"
    },
    timePeriods: {
      week4: "Há 4 Semanas",
      week3: "Há 3 Semanas",
      week2: "Há 2 Semanas",
      week1: "Semana Passada",
      current: "Atual"
    },
    errors: {
      loading: "Falha ao carregar dados de satisfação. Por favor, tente novamente.",
    },
    status: {
      loading: 'Carregando...',
      noData: 'Nenhum dado disponível para este período',
      error: 'Falha ao carregar dados de análise',
      online: "Sistema Online",
      offline: "Sistema Offline",
      responseTime: "Tempo Médio de Resposta",
      queueLength: "Fila",
      uptime: "Tempo de Atividade"
    },
    periods: {
      daily: 'Diário',
      weekly: 'Semanal',
      monthly: 'Mensal',
      allTime: 'Todo o Tempo'
    },
    metrics: {
      totalQueries: 'Consultas Totais',
      uniqueUsers: 'Usuários Únicos',
      avgResponseTime: 'Tempo Médio de Resposta',
      satisfaction: 'Satisfação do Usuário'
    },
    table: {
      rank: 'Rank',
      query: 'Consulta',
      count: 'Contagem',
      avgTime: 'Tempo Médio'
    },
    chartLabels: {
      categories: 'Áreas',
      serviceCategories: 'Áreas de Conhecimento',
      byUsage: 'por Uso',
      category: 'Área'
    },
    tooltips: {
      selectPeriod: 'Selecionar período de tempo',
      selectDate: 'Selecionar data',
      exportData: 'Exportar dados'
    },
    gauge: {
      historical: 'Tendências Históricas',
      vsPrevious: 'vs período anterior',
      target: 'Alvo'
    },
    ratings: {
      poor: "Ruim",
      average: "Médio",
      good: "Bom",
      excellent: "Excelente"
    },
    slower: 'mais lento',
    faster: 'mais rápido',
    percentage: 'Porcentagem',
    note: 'Abaixo estão estatísticas de uso e resumos de feedback de usuários.',
    usageStats: 'Estatísticas de Uso',
    peakUsers: 'Usuários Concorrentes de Pico',
    activeChats: 'Chats Ativos',
    usageTrend: 'Tendência de Uso',
    topQueries: 'Consultas Principais',
    feedbackSamples: 'Amostras de Feedback de Usuários',
    close: 'Fechar',
    chartComingSoon: 'Visualização de gráfico interativo em breve...',
    retry: 'Tentar Novamente',
    dailyQueries: 'Consultas Diárias',
    export: 'Exportar Dados',
    dateRange: 'Intervalo de Datas',
    startDate: 'Data de Início',
    endDate: 'Data de Término',
    rank: 'Rank',
    query: 'Consulta',
    count: 'Contagem',
    avgTime: 'Tempo Médio',
    serviceUsage: 'Uso por Área de Conhecimento',
    usageTrends: 'Tendências de Uso',
    week: 'Semana Passada',
    month: 'Mês Passado',
    quarter: 'Trimestre Passado',
    year: 'Ano Passado',
    uniqueUsers: 'Usuários Únicos',
    satisfactionRate: 'Taxa de Satisfação',
    satisfactionAnalysis: 'Análise de Satisfação do Usuário'
  },
  brandName: 'Genie AI: Seu Assistente Governamental Digital',
  nav: {
    systemStatus: 'Status do Sistema',
    menu: 'Menu',
    analytics: 'Análises',
    userProfile: 'Perfil do Usuário',
    settings: 'Configurações',
    logout: 'Sair',
    profile: 'Meu Perfil',
    toggleSidebar: 'Alternar barra lateral',
    changeLanguage: 'Mudar idioma',
    administration: "Administração",
    languages: {
      english: 'Inglês',
      french: 'Francês',
      swahili: 'Suaíli'
    }
  },
  systemStatus: {
    title: 'Status do Serviço',
    services: 'Serviços',
    operational: 'Operacional',
    degraded: 'Degradado',
    outage: 'Interrupção',
    allOperational: 'Todos os Sistemas',
    someIssues: 'Alguns Problemas',
    majorIssues: 'Problemas Graves',
    checking: 'Verificando...',
    nextDeadline: 'Próximo Prazo',
    days: 'dias',
    viewDetails: 'Ver Detalhes'
  },
  services: {
    eCitizen: 'Portal eCitizen',
    taxFiling: 'Sistema de Declaração de Impostos',
    idApplication: 'Aplicação de ID',
    businessReg: 'Registro de Negócios',
    drivingLicense: 'Carteira de Motorista'
  },
  deadlines: {
    taxFiling: 'Prazo para Declaração de Impostos',
    businessRenewal: 'Renovação de Licença de Negócios',
    idRenewal: 'Renovação de Cartão de ID',
    vehicleRegistration: 'Prazo para Registro de Veículos'
  },
  sidebar: {
    governmentServices: 'Áreas de Conhecimento',
    chatHistory: 'Histórico de Chat',
    searchPlaceholder: 'Pesquisar áreas de conhecimento...',
    createFolder: 'Criar Pasta',
    editFolder: 'Editar Pasta',
    folderName: 'Nome da Pasta',
    folderNamePlaceholder: 'Digite o nome da pasta',
    moveChat: 'Mover Chat',
    moveChatTo: 'Mover Chat Para',
    selectFolder: 'Selecionar Pasta',
    deleteChat: 'Excluir Chat',
    deleteChatConfirm: 'Tem certeza de que deseja excluir este chat?',
    deleteChatWarning: 'Esta ação não pode ser desfeita.',
    renameChat: "Renomear Chat",
    chatTitle: "Título do Chat",
    chatTitlePlaceholder: "Digite um título para este chat",
    deleteFolder: "Excluir Pasta",
    deleteFolderConfirm: "Tem certeza de que deseja excluir a pasta '{name}'?",
    chatsMoveWarning: "Todos os chats nesta pasta serão movidos para a pasta padrão.",
    weatherTitle: "Previsão do Tempo",
    weatherLoading: "Carregando dados do tempo...",
    weatherError: "Incapaz de carregar dados do tempo. Por favor, tente novamente.",
    weatherLocationLoading: 'Carregando localização...',
    weatherErrorDefault: 'Não foi possível recuperar os dados do tempo.',
    weatherGeolocationUnsupported: 'Geolocalização não suportada pelo seu navegador.',
    weatherRefresh: 'Atualizar Tempo',
    weatherConditions: {
      clear: 'Limpo',
      partlycloudy: 'Parcialmente Nublado',
      cloudy: 'Nublado',
      overcast: 'Encoberto',
      rain: 'Chuva',
      shower: 'Aguaceiro',
      thunderstorm: 'Trovoada',
      snow: 'Neve'
    },
    title: 'Informações e Recursos',
    noChats: 'Nenhum chat recente',
    relatedDocs: 'Documentos Relacionados',
    noDocuments: 'Nenhum documento relacionado',
    faq: 'Perguntas Frequentes',
    tab: {
      all: 'Todos os Chats',
      folders: 'Pastas',
      starred: 'Favoritos',
      archived: 'Arquivados'
    },
    savedChats: 'Chats Salvos',
    chats: "Chats",
    allChats: "Todos os Chats",
    folders: "Pastas",
    starredChats: "Chats Favoritos",
    archivedChats: "Chats Arquivados",
    noFolder: "Sem Pasta",
    emptyFolder: "Esta pasta está vazia. Mova conversas para cá do menu de chat.",
    noStarredChats: "Ainda não há conversas favoritas. Favorite uma conversa para adicioná-la aqui.",
    noArchivedChats: "Ainda não há conversas arquivadas.",
    noSearchResults: 'Nenhuma conversa encontrada para "{term}"',
    loadingChats: "Carregando conversas...",
    errorLoadingConversations: "Falha ao carregar conversas. Por favor, tente novamente.",
    errorLoadingUser: "Dados do usuário incompletos. Por favor, recarregue a página.",
    errorNoUser: "Dados do usuário ausentes. Por favor, recarregue a página.",
    retry: "Tentar Novamente",
    message: "mensagem",
    messages: "mensagens",
    created: "Criado",
    updated: "Atualizado",
    star: "Favoritar",
    unstar: "Desfavoritar",
    archive: "Arquivar",
    chatStarred: "Conversa favoritada",
    chatUnstarred: "Conversa desfavoritada",
    chatArchived: "Conversa arquivada",
    chatUnarchived: "Conversa desarquivada",
    errorUpdatingChat: "Falha ao atualizar conversa",
    chatRenamed: "Conversa renomeada com sucesso",
    errorRenamingChat: "Falha ao renomear conversa",
    chatDeleted: "Conversa excluída com sucesso",
    errorDeletingChat: "Falha ao excluir conversa",
    chatMoved: "Conversa movida com sucesso",
    errorMovingChat: "Falha ao mover conversa",
    noPreview: "Nenhuma pré-visualização disponível",
    searchConversations: 'Pesquisar conversas...',
    selectFolderInstruction: "Selecione uma pasta para visualizar suas conversas",
    folderCreated: "Pasta criada com sucesso",
    errorCreatingFolder: "Falha ao criar pasta",
    errorLoadingFolders: "Falha ao carregar pastas",
    folderUpdated: "Pasta atualizada com sucesso",
    errorUpdatingFolder: "Falha ao atualizar pasta",
    folderDeleted: "Pasta excluída com sucesso",
    errorDeletingFolder: "Falha ao excluir pasta",
    chatRemovedFromFolders: "Conversa removida da pasta",
    errorRemovingChat: "Falha ao remover conversa da pasta",
    id: "ID",
    labels: "Etiquetas",
    confidence: "Confiança",
    unknown: "Desconhecido"
  },
  leftPanel: {
    cat1: {
      name: '1. Identidade & Registro Civil',
      children: ['Certidões de nascimento', 'Cartões de ID nacional', 'Passaportes', 'Certidões de casamento e óbito', 'Registro de eleitores']
    },
    cat2: {
      name: '2. Saúde & Serviços Sociais',
      children: ['Acesso à saúde pública', 'Programas de vacinação', 'Seguro de saúde', 'Benefícios por deficiência', 'Assistência social e alimentar']
    },
    cat3: {
      name: '3. Educação & Aprendizagem',
      children: ['Escolas públicas e universidades', 'Bolsas e empréstimos estudantis', 'Programas de educação para adultos', 'Recursos de aprendizado online']
    },
    cat4: {
      name: '4. Emprego & Serviços Trabalhistas',
      children: ['Busca de emprego e benefícios de desemprego', 'Proteções ao trabalhador e direitos laborais', 'Regulamentos de segurança no trabalho', 'Treinamento de habilidades e aprendizados']
    },
    cat5: {
      name: '5. Impostos & Receita',
      children: ['Declaração de imposto de renda e reembolsos', 'Pagamentos de imposto sobre propriedade', 'Conformidade fiscal empresarial', 'Alfândega e direitos de importação']
    },
    cat6: {
      name: '6. Segurança Pública & Justiça',
      children: ['Polícia e serviços de emergência', 'Tribunais e serviços de assistência legal', 'Relato de crimes', 'Leis de proteção ao consumidor']
    },
    cat7: {
      name: '7. Transporte & Mobilidade',
      children: ["Carteiras de motorista e registro de veículos", 'Transporte público e infraestrutura', 'Violações de trânsito e multas', 'Programas de segurança rodoviária']
    },
    cat8: {
      name: '8. Habitação & Desenvolvimento Urbano',
      children: ['Assistência habitacional pública', 'Registro de propriedade e registros de terras', 'Empréstimos e subsídios habitacionais', 'Zoneamento e permissões de construção']
    },
    cat9: {
      name: '9. Utilidades & Meio Ambiente',
      children: ['Serviços de água e eletricidade', 'Gerenciamento de resíduos e reciclagem', 'Regulamentos ambientais', 'Iniciativas de energia renovável']
    },
    cat10: {
      name: '10. Negócios & Comércio',
      children: ['Registro e licenciamento de negócios', 'Regulamentos e permissões comerciais', 'Subsídios e incentivos para pequenas empresas', 'Suporte a e-commerce e negócios digitais']
    },
    cat11: {
      name: '11. Segurança Social & Pensões',
      children: ['Benefícios de aposentadoria', 'Gerenciamento de fundos de pensão', 'Benefícios para sobreviventes', 'Pensões por deficiência']
    },
    cat12: {
      name: '12. Comunidade & Engajamento Cívico',
      children: ['Votação e eleições', 'Feedback público e reclamações de cidadãos', 'Voluntariado e programas comunitários', 'Participação no governo local']
    }
  },
  settings: {
    title: 'Configurações',
    save: 'Salvar',
    close: 'Fechar',
    saveSettings: 'Salvar Configurações',
    savingSettings: "Salvando suas configurações...",
    settingsSaved: "Configurações salvas com sucesso!",
    saveSuccess: 'Configurações salvas com sucesso',
    saveError: 'Erro ao salvar configurações',
    display: 'Exibição',
    displayLanguage: 'Idioma de Exibição',
    languages: {
      english: 'Inglês',
      french: 'Francês',
      swahili: 'Suaíli'
    },
    theme: 'Tema',
    themes: {
      light: 'Claro',
      dark: 'Escuro',
      system: 'Sistema'
    },
    fontSize: 'Tamanho da Fonte',
    notifications: 'Notificações',
    emailUpdates: 'Atualizações por e-mail',
    soundNotifications: 'Notificações sonoras',
    accountManagement: 'Gerenciamento de Conta',
    emailAddress: 'Endereço de E-mail',
    emailAddressPlaceholder: 'Seu endereço de e-mail',
    password: 'Senha',
    changePassword: 'Alterar Senha',
    resetUserData: 'Redefinir Dados do Usuário',
    resetUserDataDesc: 'Isso limpará todos os dados do seu perfil e histórico de chat.',
    deleteAccount: 'Excluir Conta',
    deleteAccountDesc: 'Isso excluirá permanentemente sua conta e todos os dados associados.',
    edit: 'Editar',
    standardAccount: 'Conta Padrão',
    confirmEmailChange: 'Confirmar Alteração de E-mail',
    pleaseEnterPassword: 'Por favor, digite sua senha',
    cancel: 'Cancelar',
    account: {
      title: 'Conta',
      resetDescription: 'Isso limpará todos os dados do seu perfil e histórico de chat.',
      confirmReset: 'Tem certeza de que deseja redefinir todos os seus dados? Isso não pode ser desfeito.',
      resetComplete: 'Seus dados foram redefinidos.'
    },
    language: {
      title: 'Idioma',
      selectLabel: 'Idioma de Exibição'
    },
    appearance: {
      title: 'Aparência',
      lightTheme: 'Claro',
      darkTheme: 'Escuro',
      systemTheme: 'Sistema'
    },
    confirmDeleteAccount: 'Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita.',
    confirmAccountDeletion: 'Confirmar Exclusão da Conta',
    accountDeletionWarning: 'Aviso: Esta ação é permanente e não pode ser desfeita. Todos os seus dados serão excluídos permanentemente.',
    deletionReason: 'Motivo da exclusão (opcional):',
    deletionReasonPlaceholder: 'O que o levou a decidir excluir sua conta?',
    enterPasswordConfirm: 'Digite sua senha para confirmar:',
    currentPasswordPlaceholder: 'Sua senha atual',
    deleting: 'Excluindo...',
    permanentlyDeleteAccount: 'Excluir Conta',
    accountDeletedSuccess: 'Sua conta foi excluída com sucesso.',
    incorrectPassword: 'Senha incorreta',
    accountDeletionFailed: 'Falha ao excluir a conta. Por favor, tente novamente mais tarde.',
    confirmChange: 'Confirmar Alteração',
    processing: 'Processando...',
    userDataReset: 'Seus dados de perfil foram redefinidos com sucesso.',
    failedToResetUserData: 'Falha ao redefinir seus dados de perfil. Por favor, tente novamente mais tarde.',
    changingEmailTo: 'Alterando seu e-mail para',
    will: 'irá',
    logOutSystem: 'Desconectá-lo do sistema',
    sendVerificationLink: 'Enviar um link de verificação para seu novo e-mail',
    requireVerification: 'Exigir verificação antes de você poder fazer login novamente',
    checkNewEmailVerification: 'Por favor, verifique seu novo e-mail para instruções de verificação.',
    unableToVerifyEmail: 'Incapaz de verificar o e-mail. Por favor, tente novamente.',
    emailAlreadyInUse: 'E-mail já em uso',
    enterValidEmail: 'Por favor, digite um endereço de e-mail válido',
    failedToUpdateEmail: 'Falha ao atualizar o e-mail. Por favor, tente novamente.',
    passwordResetInitiated: 'Um link de redefinição de senha foi enviado para seu endereço de e-mail.',
    unableToLoadUser: 'Incapaz de carregar informações do usuário. Por favor, tente novamente.',
    retry: 'Tentar Novamente',
    user: 'Usuário',
    loadingUserInfo: 'Carregando informações do usuário...',
    resetUserDataTitle: "Redefinir Dados do Usuário",
    confirmResetUserData: "Tem certeza de que deseja redefinir todos os dados do seu perfil? Isso limpará todas as informações do seu perfil e histórico de chat, mas manterá suas credenciais de conta.",
    reset: "Redefinir",
    deleteAccountTitle: "Excluir Conta"
  },
  userProfile: {
    title: 'Perfil do Usuário',
    privacyInfo: "Ao fornecer mais informações, você obterá respostas mais precisas e significativas do chatbot. Por favor, revise nossa",
    privacyPolicyLink: 'Política de Privacidade',
    tabComingSoon: 'Esta aba está em desenvolvimento e estará disponível em breve.',
    saveSuccess: 'Perfil salvo com sucesso',
    loadError: 'Erro ao carregar dados do perfil',
    saveError: 'Erro ao salvar perfil',
    confirmSaveTitle: "Salvar Perfil",
    confirmSave: "Tem certeza de que deseja salvar essas alterações?",
    confirmCancel: 'Você tem alterações não salvas. Tem certeza de que deseja cancelar?',
    confirmLeave: 'Tem certeza de que deseja sair? Qualquer alteração não salva será perdida.',
    confirmDiscardChanges: 'Descartar alterações não salvas?',
    uploadPhoto: 'Carregar Foto',
    uploadFile: 'Carregar Arquivo',
    photoRequirements: 'A foto deve ser clara, recente e mostrar seu rosto completo',
    biometricRequirements: 'Apenas arquivos de dados biométricos oficiais são aceitos',
    documentUpload: 'Upload de Documento',
    validationTitle: 'Por favor, corrija os seguintes erros:',
    profileIcon: 'Ícone do Perfil',
    change: 'Alterar',
    chooseProfileIcon: 'Escolha um Ícone de Perfil',
    presetIcons: 'Ícones Pré-definidos',
    upload: 'Carregar',
    initials: 'Iniciais',
    clickToUpload: 'Clique para carregar',
    useThisImage: 'Usar Esta Imagem',
    useInitials: 'Usar Iniciais',
    tabs: {
      tab1: 'Dados de Identificação Pessoal',
      tab2: 'Registro Civil & Documentação',
      tab3: 'Informações de Endereço & Residência',
      tab4: 'Documentos de Identidade & Viagem',
      tab5: 'Registros de Saúde & Médicos',
      tab6: 'Dados de Emprego & Econômicos',
      tab7: 'Registros Educacionais & Acadêmicos',
      tab8: 'Dados Financeiros & Fiscais',
      tab9: 'Seguridade Social & Bem-Estar',
      tab10: 'Registros Criminais & Legais',
      tab11: 'Transporte & Mobilidade',
      tab12: 'Participação Cívica & Política'
    },
    actions: {
      cancel: 'Cancelar',
      save: 'Salvar Perfil',
      previous: 'Anterior',
      next: 'Próximo',
      saving: 'Salvando...'
    },
    fields: {
      fullName: 'Nome completo (incluindo pseudônimos)',
      dob: 'Data de nascimento',
      gender: 'Gênero',
      nationality: 'Nacionalidade',
      maritalStatus: 'Estado civil',
      photograph: 'Fotografia',
      biometric: 'Impressões digitais / Dados biométricos',
      birthCert: 'Certidão de nascimento',
      deathCert: 'Certidão de óbito',
      marriageDivorce: 'Registros de casamento / divórcio',
      adoption: 'Registros de adoção',
      citizenship: 'Documentos de cidadania / naturalização',
      immigration: 'Histórico de imigração & visto',
      currentAddress: 'Endereço residencial atual',
      previousAddresses: 'Endereços anteriores',
      postalCode: 'Código Postal',
      country: 'País',
      residencyStatus: 'Status de Residência',
      homeOrRental: 'Propriedade ou detalhes de aluguel',
      utilityBills: 'Contas de utilidades vinculadas ao endereço',
      landRecords: 'Registros de terras e propriedade',
      idCard: 'Número do cartão de ID nacional',
      passport: 'Detalhes do passaporte',
      driversLicense: "Carteira de motorista",
      voterId: 'ID de eleitor',
      ssn: 'Seguridade Social / Número de Seguro Nacional',
      militaryRecords: 'Registros de serviço militar',
      medicalHistory: 'Histórico médico e condições de saúde',
      vaccinations: 'Registros de vacinação',
      insuranceDetails: 'Detalhes do seguro de saúde',
      disability: 'Status de deficiência',
      bloodType: 'Tipo Sanguíneo',
      organDonor: 'Status de doador de órgãos',
      prescriptions: 'Prescrições e tratamentos recebidos',
      mentalHealth: 'Histórico de saúde mental',
      eHistory: 'Histórico de emprego',
      currentEmployer: 'Detalhes do empregador atual',
      workPermits: 'Permissões de trabalho e contratos laborais',
      certifications: 'Certificações profissionais e licenças',
      unemployment: 'Status de desemprego e benefícios recebidos',
      tin: 'Número de identificação fiscal (TIN)',
      businessAffiliations: 'Propriedade de negócios e afiliações a empresas',
      schools: 'Escolas e universidades frequentadas',
      education: 'Educação',
      degrees: 'Diplomas, graus e certificações',
      performance: 'Desempenho acadêmico e pontuações de testes',
      academicRecords: "Registros Acadêmicos",
      scholarships: 'Bolsas e auxílio financeiro recebidos',
      incomeTax: 'Registros de imposto de renda',
      bankAccounts: 'Contas bancárias e financeiras',
      propertyTax: 'Pagamentos de imposto sobre propriedade',
      businessTax: 'Declarações fiscais empresariais',
      pensionContrib: 'Contribuições e saques de pensão',
      loanAid: 'Registros de empréstimos e auxílio governamental',
      pensionStatus: 'Status de pensão e contribuições',
      childcare: 'Suporte a cuidados infantis',
      foodAssistance: 'Assistência alimentar / programas de bem-estar',
      housingAssistance: 'Assistência habitacional',
      policeRecords: 'Registros policiais (histórico criminal, prisões, acusações)',
      courtCases: 'Histórico de casos judiciais',
      finesPenalties: 'Multas e penalidades',
      paroleProbation: 'Status de liberdade condicional ou probation',
      citizenshipRevocation: 'Revogação de cidadania (se aplicável)',
      vehicleReg: 'Detalhes de registro de veículo',
      trafficViolations: 'Violações de trânsito e multas',
      licenseHistory: 'Histórico de carteira de motorista e endossos',
      publicTransportCard: 'Uso de cartão de transporte público',
      voterRegistration: 'Detalhes de registro de eleitor',
      electionHistory: 'Histórico de participação em eleições',
      partyMembership: 'Filiação a partido político',
      militaryStatus: 'Status de serviço militar ou conscrição',
      publicServiceRoles: 'Funções de serviço público'
    },
    placeholders: {
      fullName: 'Digite seu nome legal completo',
      nationality: 'Digite sua nacionalidade',
      searchCountries: 'Pesquisar países...',
      selectCountry: 'Selecione um país',
      searchDisciplines: "Pesquisar disciplinas...",
      selectDiscipline: "Selecione uma disciplina",
      searchDegrees: "Pesquisar graus...",
      selectDegree: "Selecione um grau"
    },
    validation: {
      nameRequired: 'Nome completo é obrigatório',
      dobRequired: 'Data de nascimento é obrigatória',
      dobFuture: 'Data de nascimento não pode ser no futuro',
      requiredField: '{field} é obrigatório',
      invalidFormat: 'Formato inválido para {field}',
      futureDate: 'Data não pode ser no futuro',
      invalidSelection: 'Por favor, faça uma seleção válida',
      passwordLength: 'A senha deve ter pelo menos 8 caracteres',
      matchError: 'Campos não coincidem'
    },
    errors: {
      savingFailed: 'Falha ao salvar perfil',
      loadingFailed: 'Falha ao carregar dados do perfil',
      invalidForm: 'Por favor, preencha todos os campos obrigatórios',
      invalidFileType: 'Tipo de arquivo inválido',
      fileTooLarge: 'Arquivo muito grande',
      countryLoadError: 'Erro ao carregar países',
      countryUpdateError: 'Erro ao atualizar país'
    },
    notifications: {
      saveSuccess: 'Perfil salvo com sucesso',
      saveFailed: 'Falha ao salvar perfil',
      loadSuccess: 'Perfil carregado com sucesso',
      loadFailed: 'Falha ao carregar perfil',
      fieldRequired: 'Este campo é obrigatório',
      uploadSuccess: 'Arquivo carregado com sucesso',
      uploadFailed: 'Falha ao carregar arquivo',
      formChanged: 'Você tem alterações não salvas',
      sessionExpired: 'Sua sessão expirou, por favor faça login novamente',
      profileUpdated: 'Seu perfil foi atualizado',
      profileIncomplete: 'Seu perfil está incompleto'
    },
    instructions: {
      fullNameHelp: 'Digite seu nome legal completo como aparece em seus documentos oficiais',
      dobHelp: 'Digite sua data de nascimento no formato MM/DD/AAAA',
      uploadPhotoHelp: 'Carregue uma foto recente. O arquivo deve ser JPG, PNG ou GIF e menos de 2MB',
      passwordHelp: 'A senha deve ter pelo menos 8 caracteres com uma letra maiúscula, um número e um caractere especial',
      documentHelp: 'Formatos aceitos: PDF, JPG, PNG (máx 5MB)',
      requiredFields: 'Campos marcados com * são obrigatórios',
      selectFromList: 'Por favor, selecione uma opção da lista',
      nextTab: 'Continuar para a próxima seção',
      previousTab: 'Retornar à seção anterior',
      saveInstructions: 'Clique em Salvar para armazenar suas informações',
      cancelInstructions: 'Clique em Cancelar para descartar alterações'
    },
    completionStatus: {
      notStarted: 'Não Iniciado',
      inProgress: 'Em Progresso',
      complete: 'Completo',
      percentComplete: '{percent}% completo',
      tabsCompleted: '{completed} de {total} seções completas',
      tabComplete: 'Seção completa!'
    },
    gender: {
      male: 'Masculino',
      female: 'Feminino',
      other: 'Outro',
      preferNot: 'Prefiro não dizer'
    },
    maritalStatus: {
      single: 'Solteiro',
      married: 'Casado',
      divorced: 'Divorciado',
      widowed: 'Viúvo',
      other: 'Outro'
    },
    residencyStatuses: {
      citizen: 'Cidadão',
      permanentResident: 'Residente Permanente',
      temporaryResident: 'Residente Temporário',
      other: 'Outro'
    },
    employmentStatuses: {
      employed: 'Empregado',
      selfEmployed: 'Autônomo',
      unemployed: 'Desempregado',
      student: 'Estudante',
      retired: 'Aposentado',
      homemaker: 'Dono de Casa',
      other: 'Outro'
    },
    educationLevels: {
      primary: 'Educação Primária',
      secondary: 'Educação Secundária',
      highSchool: 'Ensino Médio',
      vocational: 'Treinamento Vocacional',
      associate: 'Grau Associado',
      bachelor: 'Bacharelado',
      master: 'Mestrado',
      doctoral: 'Doutorado',
      professional: 'Grau Profissional',
      other: 'Outro'
    },
    proficiencyLevels: {
      native: 'Nativo',
      fluent: 'Fluente',
      advanced: 'Avançado',
      intermediate: 'Intermediário',
      basic: 'Básico'
    },
    bloodTypes: {
      aPositive: 'A+',
      aNegative: 'A-',
      bPositive: 'B+',
      bNegative: 'B-',
      abPositive: 'AB+',
      abNegative: 'AB-',
      oPositive: 'O+',
      oNegative: 'O-',
      unknown: 'Desconhecido'
    },
    languages: {
      english: 'Inglês',
      french: 'Francês',
      swahili: 'Suaíli',
      arabic: 'Árabe',
      spanish: 'Espanhol',
      portuguese: 'Português',
      chinese: 'Chinês',
      japanese: 'Japonês',
      german: 'Alemão',
      russian: 'Russo',
      hindi: 'Hindi',
      urdu: 'Urdu',
      other: 'Outro'
    },
    yesNo: {
      yes: 'Sim',
      no: 'Não'
    },
    select: 'Por favor, selecione',
    existingFile: 'Arquivo existente',
    noMatchingCountries: 'Nenhum país correspondente encontrado',
    noMatchingDisciplines: "Nenhuma disciplina correspondente encontrada",
    noMatchingDegrees: "Nenhum grau correspondente encontrado",
    educationOptions: [
      "Contabilidade", "Engenharia Aeroespacial", "Ciência Agrícola", "Antropologia", "Arquitetura",
      "História da Arte", "Inteligência Artificial", "Astronomia", "Astrofísica", "Bioquímica",
      "Engenharia Biomédica", "Biotecnologia", "Administração de Empresas", "Engenharia Química",
      "Química", "Engenharia Civil", "Comunicações", "Engenharia de Computação", "Ciência da Computação",
      "Gerenciamento de Construção", "Justiça Criminal", "Cibersegurança", "Ciência de Dados", "Odontologia",
      "Economia", "Educação", "Engenharia Elétrica", "Educação Elementar", "Literatura Inglesa",
      "Engenharia Ambiental", "Ciência Ambiental", "Design de Moda", "Estudos Cinematográficos",
      "Finanças", "Belas Artes", "Ciência de Alimentos", "Ciência Forense", "Design de Jogos",
      "Geografia", "Geologia", "Design Gráfico", "Administração de Saúde", "História",
      "Gerenciamento de Hospitalidade", "Recursos Humanos", "Design Industrial", "Engenharia Industrial", "Sistemas de Informação",
      "Tecnologia da Informação", "Design de Interiores", "Negócios Internacionais", "Relações Internacionais",
      "Jornalismo", "Direito", "Ciência da Biblioteca", "Linguística", "Gerenciamento", "Marketing",
      "Ciência de Materiais", "Matemática", "Engenharia Mecânica", "Estudos de Mídia", "Medicina",
      "Meteorologia", "Microbiologia", "Música", "Nanotecnologia", "Enfermagem", "Nutrição",
      "Terapia Ocupacional", "Oceanografia", "Engenharia de Petróleo", "Farmácia", "Filosofia",
      "Fotografia", "Educação Física", "Fisioterapia", "Física", "Ciência Política",
      "Psicologia", "Administração Pública", "Saúde Pública", "Relações Públicas", "Robótica",
      "Educação Secundária", "Trabalho Social", "Sociologia", "Engenharia de Software", "Educação Especial",
      "Gerenciamento Esportivo", "Estatística", "Engenharia de Sistemas", "Artes Teatrais", "Turismo",
      "Planejamento Urbano", "Medicina Veterinária", "Desenvolvimento Web", "Biologia da Vida Selvagem", "Zoologia"
    ],
    degreeOptions: [
      "Grau Associado", "Bacharel em Artes (BA)", "Bacharel em Ciências (BS)", "Bacharel em Engenharia (BEng)",
      "Bacharel em Administração de Empresas (BBA)", "Bacharel em Belas Artes (BFA)", "Bacharel em Educação (BEd)",
      "Bacharel em Medicina (MBBS)", "Bacharel em Direito (LLB)", "Mestre em Artes (MA)", "Mestre em Ciências (MS)",
      "Mestre em Administração de Empresas (MBA)", "Mestre em Engenharia (MEng)", "Mestre em Belas Artes (MFA)",
      "Mestre em Educação (MEd)", "Mestre em Direito (LLM)", "Mestre em Saúde Pública (MPH)",
      "Doutor em Filosofia (PhD)", "Doutor em Medicina (MD)", "Doutor em Educação (EdD)",
      "Doutor em Administração de Empresas (DBA)", "Doutor em Jurisprudência (JD)", "Diploma Profissional",
      "Diploma Técnico", "Certificado Vocacional", "Certificado de Pós-Graduação", "Diploma de Pós-Graduação", "Pós-Doutorado"
    ],
    aria: {
      tabList: 'Seções do formulário de perfil',
      nextButton: 'Ir para a próxima seção',
      prevButton: 'Ir para a seção anterior',
      closeButton: 'Fechar formulário de perfil',
      saveButton: 'Salvar dados de perfil',
      requiredField: 'Campo obrigatório',
      dropdownSelect: 'Selecionar uma opção'
    }
  },
  chatbot: {
    placeholder: 'Digite sua consulta aqui...',
    sendButton: 'Enviar',
    fileReceived: 'Arquivo recebido com sucesso.',
    fileUploadError: 'Erro ao carregar arquivo.',
    processingError: 'Erro ao processar sua solicitação.',
    welcomeMessage: 'Bem-vindo! Como posso ajudá-lo com os serviços governamentais do Quênia hoje?',
    attachFile: 'Anexar Arquivo',
    fileTooLarge: 'Arquivo muito grande. Tamanho máximo é {maxSize}.',
    saveChat: 'Salvar Chat',
    chatSaved: 'Chat Salvo',
    chatTitle: 'Título do Chat',
    chatTitlePlaceholder: 'Digite um título para este chat',
    selectFolder: 'Selecionar Pasta',
    newChat: 'Novo Chat',
    clearContext: 'Limpar contexto e iniciar uma nova conversa',
    unsavedChanges: 'Você tem alterações não salvas. Tem certeza de que deseja iniciar um novo chat?',
    whatCanIHelp: "Como posso ajudá-lo hoje?",
    justChat: "Apenas Chat",
    queryContext: "Contexto da Consulta",
    contextAdded: 'Contexto adicionado à sua consulta',
    contextRemoved: 'Contexto removido da sua consulta',
    sessionUpdated: 'Sessão atualizada',
    newChatStarted: 'Iniciada uma nova conversa',
    loadError: 'Incapaz de carregar o histórico de chat',
    responsePrefix: "Recebi sua mensagem",
    withContext: "com contexto",
    conversationLoaded: "Conversa carregada com sucesso!",
    saveConfirmTitle: "Salvar Conversa Existente",
    saveConfirmMessage: "Salvar conversa existente?",
    loadConfirmTitle: "Carregar Conversa Existente",
    loadConfirmMessage: "Você tem alterações não salvas. Deseja descartá-las e carregar a conversa selecionada, ou salvar a conversa atual primeiro?",
    loadAndDiscard: "Carregar e Descartar",
    saveAndLoad: "Salvar e Carregar",
    saveAndStartNew: "Salvar e Iniciar Novo",
    discardAndStartNew: "Descartar e Iniciar Novo",
    newChatTitle: "Iniciar Novo Chat",
    exportChat: 'Exportar Chat',
    exportFilename: 'Nome do Arquivo',
    exportFilenamePlaceholder: 'Digite o nome do arquivo',
    exportButton: 'Exportar',
    exportSuccess: 'Chat exportado com sucesso',
    exportError: 'Falha ao exportar chat. Por favor, tente novamente.'
  },
  quickhelp: {
    // Labels (Short for UI)
    applyForID: "Solicitar ID",
    payTaxes: "Pagar Impostos",
    startBusiness: "Iniciar Negócio",
    findHealthcare: "Saúde",
    educationServices: "Educação",
    transportLicenses: "Transporte",
    housingPrograms: "Habitação",
    findJobs: "Empregos",
    justChat: "Apenas Conversar",

    // User Prompts (Visible Text - First Person - what user sees in chat)
    justChatUserPrompt: "Gostaria de conversar sobre serviços governamentais",
    applyForIDUserPrompt: "Preciso de informações sobre como solicitar um cartão de ID nacional",
    payTaxesUserPrompt: "Qual é o processo para pagar meus impostos online?",
    startBusinessUserPrompt: "Guie-me pelos passos para registrar um novo negócio",
    findHealthcareUserPrompt: "Onde posso encontrar informações sobre serviços de saúde pública?",
    educationServicesUserPrompt: "Quais serviços de educação estão disponíveis para meus filhos?",
    transportLicensesUserPrompt: "Como renovo minha carteira de motorista?",
    housingProgramsUserPrompt: "Conte-me sobre programas de habitação acessível no Quênia",
    findJobsUserPrompt: "Quais oportunidades de emprego governamental estão disponíveis atualmente?",

    // System Prompts (Hidden from User - detailed prompts sent to LLM)
    applyForIDPrompt: "Act as a helpful Kenyan civil registration expert. Explain the steps for obtaining a National ID (Maisha Namba) or replacing a lost one. IMPORTANT: Provide a clear list of required documents (e.g., Birth Certificate, copies of parents' IDs) and advise the user to visit their nearest Huduma Centre or Registrar of Persons office. RULE: Always refer to the application as 'Genie AI'.",

    payTaxesPrompt: "Act as a KRA (Kenya Revenue Authority) guide. Explain the process of filing returns, applying for a KRA PIN, or resetting a password on the iTax portal. IMPORTANT: Remind the user of the June 30th deadline for annual returns and guide them on how to file Nil returns if they had no income. RULE: Always refer to the application as 'Genie AI'.",

    startBusinessPrompt: "Act as a business consultant for eCitizen services. Guide the user through business name reservation and company registration in Kenya. IMPORTANT: Explain the current costs for name search and registration, and direct the user to the official eCitizen portal to complete the application. RULE: Always refer to the application as 'Genie AI'.",

    findHealthcarePrompt: "Act as a health services navigator. Provide information on the transition from NHIF to SHIF (Social Health Insurance Fund) and how to register. IMPORTANT: Share the official USSD codes (like *263#) or website links for registration and explain the benefits of the public health cover. RULE: Always refer to the application as 'Genie AI'.",

    educationServicesPrompt: "Act as an education counselor. Discuss the CBC curriculum, NEMIS registration, or university placement via KUCCPS. IMPORTANT: Explain how parents can check national exam results via SMS or the KNEC portal when released. RULE: Always refer to the application as 'Genie AI'.",

    transportLicensesPrompt: "Act as an NTSA service guide. Explain the process for driving license renewal, vehicle inspection, or TIMS account management. IMPORTANT: Guide the user on how to log in to the eCitizen NTSA portal to apply for their Smart DL or book a vehicle inspection. RULE: Always refer to the application as 'Genie AI'.",

    housingProgramsPrompt: "Act as a housing program advisor. Explain the Affordable Housing Program (Boma Yangu) registration and voluntary contribution process. IMPORTANT: Guide the user to the Boma Yangu portal to view projects and explain the eligibility criteria for allocation. RULE: Always refer to the application as 'Genie AI'.",

    findJobsPrompt: "Act as a career coach for the public service. Guide the user on creating a profile and applying for vacancies via the Public Service Commission (PSC) portal. IMPORTANT: Advise the user to keep their academic certificates ready and to regularly check the PSC website or local dailies for MyGov advertisements. RULE: Always refer to the application as 'Genie AI'.",

    justChatPrompt: "Act as a friendly local companion. Be polite, helpful, and knowledgeable about Kenyan culture and daily life. IMPORTANT: Remind the user that while you can chat about anything, your main strength is helping them navigate Kenyan government services like **IDs**, **Taxes**, and **Business Registration**. RULE: Always refer to the application as 'Genie AI'."
  },
  common: {
    cancel: 'Cancelar',
    create: 'Criar',
    save: 'Salvar',
    move: 'Mover',
    delete: 'Excluir',
    // --- NEW KEYS ADDED ---
    ok: 'OK',
    ingest: 'Ingerir',
    retract: 'Retirar',
    loading: 'Carregando...',
    refresh: 'Atualizar'
  },
  feedback: {
    title: 'Feedback',
    button: 'Feedback',
    positive: 'Feedback positivo',
    negative: 'Feedback negativo',
    promptText: 'Esta resposta foi útil?',
    placeholder: 'Comentários adicionais...',
    submit: 'Enviar Feedback',
    close: 'Cancelar',
    thankYouMessage: 'Obrigado pelo seu feedback!',
    submitting: 'Enviando...',
    error: 'Algo deu errado. Por favor, tente novamente.',
    success: 'Obrigado pelo seu feedback!',
  },
  responseRating: {
    title: 'Ajude-nos a Melhorar',
    note: 'Seu feedback será usado para ajustar melhor o chatbot e melhorar as respostas ao longo do tempo.',
    chatbotResponse: 'Resposta do Chatbot:',
    ratingLabels: {
      1: 'Inútil',
      2: 'Ligeiramente Útil',
      3: 'Moderadamente Útil',
      4: 'Muito Útil',
      5: 'Muda a Vida'
    },
    additionalComments: 'Comentários adicionais...',
    submit: 'Enviar',
    cancel: 'Cancelar'
  },
  upload: {
    alt: 'Carregar'
  },
  details: {
    loading: 'A carregar detalhes do ficheiro...',
    title: 'Detalhes do Ficheiro',
    close: 'Fechar',
    fileName: 'Nome do Ficheiro',
    author: 'Autor',
    labels: 'Etiquetas',
    selectAll: 'Selecionar Tudo',
    loadingLabels: 'A carregar etiquetas...',
    status: 'Estado',
    fileId: 'ID do Ficheiro',
    fileType: 'Tipo de Ficheiro',
    viewFile: 'Ver Ficheiro',
    visitLink: 'Visitar Link Externo',
    openFile: 'Abrir ficheiro num novo separador',
    fileSize: 'Tamanho do Ficheiro',
    uploadDate: 'Data de Carregamento',
    hash: 'Hash SHA256',
    // --- NEW: TABS ---
    tabs: {
      details: "Detalhes",
      ingestionLog: "Log de Ingestão"
    },
    // --- NEW: LOG TAB ---
    log: {
      killActions: "Ações de Interrupção:",
      killDocument: "Interromper Este Documento",
      killProcess: "Interromper Processo de Ingestão",
      timestamp: "Carimbo de Tempo",
      level: "Nível",
      stage: "Estágio",
      message: "Mensagem",
      loadingLogs: "A carregar logs...",
      noLogs: "Nenhum log encontrado."
    },
    buttons: {
      saveMetadata: 'Guardar Metadados',
      retract: 'Retirar',
      ingest: 'Ingerir'
    },
    notifications: {
      loadError: 'Falha ao carregar os detalhes do ficheiro.',
      validationError: 'O nome do ficheiro e o autor são obrigatórios.',
      saveSuccess: 'Metadados atualizados com sucesso.',
      saveError: 'Falha ao guardar os metadados.',
      tokenError: 'Token de autenticação não encontrado nos dados do utilizador.',
      viewError: 'Não foi possível carregar o ficheiro para visualização.',
      ingestSuccess: 'Ficheiro colocado na fila para ingestão com sucesso.',
      ingestError: 'Falha ao iniciar o processo de ingestão.',
      retractSuccess: 'Ficheiro retirado com sucesso.',
      retractError: 'Falha ao retirar o ficheiro.',
      deleteSuccess: 'Ficheiro eliminado com sucesso.',
      deleteError: 'Falha ao eliminar o ficheiro.',
      // --- NEW NOTIFICATIONS ---
      ingestLabelRequired: "Por favor, selecione pelo menos uma etiqueta antes de ingerir.",
      ingestSaving: "A guardar metadados antes da ingestão...",
      ingestSaveFailed: "Falha ao guardar metadados. Ingestão cancelada.",
      logError: "Falha ao obter os logs de ingestão.",
      killDocSent: "Pedido de interrupção para este documento enviado.",
      killProcSent: "Pedido de interrupção para o processo de ingestão enviado."
    },
    confirm: {
      ingest: 'Tem a certeza que quer ingerir este ficheiro? Isto iniciará o pipeline de processamento de dados.',
      retract: 'Tem a certeza de que quer retirar este ficheiro?',
      delete: 'Tem a certeza de que quer eliminar permanentemente este ficheiro? Esta ação não pode ser anulada.',
      // --- NEW CONFIRMATIONS ---
      ingestTitle: "Confirmar Ingestão",
      retractTitle: "Confirmar Retirada",
      deleteTitle: "Confirmar Exclusão",
      killDocTitle: "Interromper Ingestão do Documento",
      killDoc: "Tem a certeza de que quer interromper a tarefa de ingestão para ESTE documento? O processo tentará uma reversão segura.",
      killProcTitle: "Interromper TODO o Processo de Ingestão",
      killProc: "AVISO: Isto irá interromper todo o serviço de ingestão de backend, afetando TODOS os ficheiros atualmente em processamento. Tem a certeza absoluta?"
    }
  },
  uploadDialog: {
    title: 'Carregar Ficheiros',
    dropzone: 'Arraste e solte ficheiros aqui, ou clique para selecionar',
    allowedTypesLabel: 'Tipos permitidos:',
    buttonUpload: 'Carregar {count} Ficheiro(s)',
    remove: 'Remover',
    uploading: 'A carregar...',
    notifications: {
      dropError: 'Apenas ficheiros podem ser largados. Verifique se está a arrastar um ficheiro válido do seu computador.',
      typeNotAllowed: 'O tipo de ficheiro "{extension}" não é permitido.',
      shortcutUnsupported: 'Ficheiros de atalho (.url) não são suportados. Por favor, arraste o ficheiro real.',
      duplicate: 'O ficheiro "{fileName}" já foi adicionado.',
      uploadSuccess: '{fileName} carregado com sucesso',
      uploadFailed: 'Falha ao carregar {fileName}.'
    }
  }
}